function cancelSearch() {
  const searchInput = document.getElementById('bc-sf-search-box-mobile');
  if (searchInput) {
    searchInput.value = '';
  }
  const searchSuggestionMobile = document.querySelector('.bc-sf-search-suggestion-mobile')
  if (searchSuggestionMobile) {
    searchSuggestionMobile.style.display = 'none';
  }
  document.querySelector('.cHeader-mobile__search').click();
  const searchBar = document.querySelector('.cSearchBar');
  if (searchBar) {
    searchBar.style.position = 'fixed';
  }
}

(function () {
    setTimeout(() => {
      if ($('.bc-sf-search-suggestion-mobile-top-panel').length) {
        $('.bc-sf-search-suggestion-mobile-top-panel').each(function(idx) {
          $('.cHeader-mobile').after( $(this) );
          $(this).hide();

          if(idx === 0) {
            $(this).addClass('first-input-search');

            $(this).find('input').attr("placeholder", "Search by name, style, collection or anything you want to!");
            $('.bc-sf-search-suggestion-mobile-top-panel.second-input-search').after( $('.popular-terms') );
            $('.popular-terms').hide();
          } else {
            $(this).addClass('second-input-search')
          }

        });
      }
    })

    let flag = true;
    $(document).on('keyup', '#bc-sf-search-box-mobile', function () {
      if ($(this).val().length < 1) {
        $('.popular-terms').show();
      } else {
        $('.popular-terms').hide();
      }
      if($(this).val().length > 2) {
        if (flag === true) {
          $('.bc-sf-search-suggestion-mobile-top-panel.first-input-search').after( $('.bc-sf-search-suggestion-wrapper.bc-sf-search-suggestion-mobile') );
          flag = false;
        }
      }
    });

    // click on the search icon on navbar
    $('a.nav-outer__btn').click(function (e) {
      e.preventDefault();
      $('.cSearchBar').appendTo('.cHeader');

      $('#bc-sf-search-box-0').val('');
      $(window).scrollTop(0);
      if ($('.bc-sf-search-suggestion').is(':visible')) {
        $('#bc-sf-search-box-0').val('');
        $('.bc-sf-search-suggestion-wrapper').hide();
        $('.bc-sf-search-suggestion').hide();
      }
      e.stopPropagation();
    });

    // clicks on btn for redirects
    $(document).on('input', '#bc-sf-search-box-0', function (event) {
      var key = event.keyCode || event.which;
      $('.bc-sf-search-suggestion [data-group="products"] .bc-sf-search-suggestion-item').each((idx) => {
        var style = $(
          '<style class="before-style">.bc-sf-search-suggestion [data-group="products"]::before{display:none}</style>'
        );
        if (idx == 2) {
          $('body').append(style);
        } else {
          $('.before-style').remove();
        }
      })

      $('.bc-sf-search-suggestion-wrapper').show();
      $('.bc-sf-search-suggestion-wrapper').addClass('container');
      $('.bc-sf-search-suggestion').addClass('ui-flex');

      if (key === 13) {
        event.preventDefault();
        $(this).next().click();
        return false;
      }
    });

    const appendSearchSuggestionToHeader = () => {
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (addedNode) {
              if (addedNode.classList != undefined && addedNode.classList.contains('bc-sf-search-suggestion-wrapper')) {
                $('header.js-header').append($('.bc-sf-search-suggestion-wrapper'));

                $('.bc-sf-search-suggestion-wrapper').show();
                $('.bc-sf-search-suggestion-wrapper').addClass('container');
                $('.bc-sf-search-suggestion').addClass('ui-flex');

                observer.disconnect();
              }
            });
          }
        }
      };

      const observer = new MutationObserver(callback);

      observer.observe(document.body, { childList: true, subtree: true });
    }

    appendSearchSuggestionToHeader();

    // toggles the body and suggestions styling when visible
    $(window).scroll(function (e) {
      if (window.innerWidth > 768) {
        if ($('.bc-sf-search-suggestion').is(':visible')) {
          $('body').css({
            height: '150vh',
          });
          $('.cFooter').css('position', 'relative');

          if ($(window).scrollTop() > 70) {
            $('.bc-sf-search-suggestion-wrapper ').css('z-index', 5);
          } else {
            $('.bc-sf-search-suggestion-wrapper ').css('z-index', 99999);
          }
        } else {
          $('body').css({
            height: '100%',
            overflow: 'initial',
          });
          $('.cFooter').css('position', 'fixed');
        }
      }
    });

    const mobileSearchBtn = document.querySelector('a.cHeader-mobile__search');
    mobileSearchBtn.classList.add('--active');

    // click on mobile search icon
    mobileSearchBtn.addEventListener('click', function (e) {
      flag = true;
      $('.bc-sf-search-btn-clear-suggestion').attr('onclick', 'cancelSearch()')
      $(window).scrollTop(0);
      // $('.cHeader-mobile').after(  $( '.bc-sf-search-suggestion-mobile-top-panel.first-input-search' ) );
      $('.bc-sf-search-suggestion-mobile-top-panel.first-input-search').find('input').attr("placeholder", "Search")
      $('.first-input-search').slideToggle();
      $('.popular-terms').slideDown();
      $('body.is-search-open .popular-terms').slideUp();
      $('.bc-sf-search-suggestion-mobile-top-panel #bc-sf-search-box-mobile').val('');
      $('.bc-sf-search-suggestion-wrapper').hide();
      $('.bc-sf-search-suggestion-mobile-top-panel #bc-sf-search-box-mobile').focus();
      if ($('body').hasClass('is-menu-open')) {
        $('.cHeader-close').click();
      }
    });

    // click on close input buton
    $('.cSearchBar .close').click(function () {
      $('#bc-sf-search-box-0').val('');
      $('.bc-sf-search-suggestion-wrapper').hide();
      $('.bc-sf-search-suggestion').hide();
      $('body').css({
        'max-height': '100%',
        overflow: 'initial',
      });
    });

    $('.cancel-btn').click(function () {
      $('.cHeader-mobile__search').trigger('click');
    });

    $('.ico-close').click(function () {
      $('.popular-terms').hide();
      $('.cSearchBar').css('position', 'fixed');
    })

    $('.ico-menu').click(function () {
      flag = true;
      $('.first-input-search').hide();
      $('.popular-terms').hide();
      // $( '.bc-sf-search-suggestion-mobile-top-panel.first-input-search' ).prependTo( '.cHeader-el--account' );
      $('.bc-sf-search-suggestion-mobile-top-panel.first-input-search').find('input').attr("placeholder", "Search")
    });
}());